import { Role } from "../../helpers/role";

export const PDSRoutes = [
  {
    name: "DRS_PDS",
    path: `/${Role.PDS}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "PDS_Home",
        path: "/",
        component: () => import("@/views/pds/Home"),
        meta: {
          authorize: [Role.PDS],
        },
      },
      {
        name: "PDS-SEARCH",
        path: "pds-search",
        component: () => import("@/views/pds/Search"),
        meta: {
          authorize: [Role.PDS],
        },
      },
      {
        name: "PDS_Distributor",
        path: "pds-distributor",
        component: () => import("@/views/pds/Distributor"),
        meta: {
          authorize: [Role.PDS],
        },
      },

      {
        name: "PDS_UploadPDS",
        path: "pds-uploadPDS",
        component: () =>
          import("@/views/pds/UploadPDS"),
        meta: {
          authorize: [Role.PDS],
        },
      },

      {
        name: "SMSCatcher",
        path: "sms",
        component: () =>
          import("@/views/pds/Sms"),
        meta: {
          authorize: [Role.PDS],
        },
      },

      

    ],
  },
];
